const getLink = spaceGroup => `/spaces/groups/${spaceGroup.id}`

const columns = [
  { key: 'position', name: 'Position', value: 'position', sortValue: 'position' },
  { key: 'title', name: 'Title', value: 'title', link: getLink },
  { key: 'description', name: 'Description', value: 'description' },
]

export default columns
